import { axiosInstance } from "@/lib/axios-instance";

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  userType?: string;
  phoneNumber?: string;
  shortBio?: string;
}

export interface CompanyProfile {
  id: string;
  companyName: string;
  shortBio?: string;
  detailedDescription?: string;
  website?: string;
  industry?: string[];
  companyType?: string[];
  stage?: number;
  city?: string;
  province?: string;
  country?: string;
  address?: string;
  contactPhone?: string;
  businessModel?: string;
  // GICS hierarchy (2-level: Industry + Sub-Industry)
  gics_industry?: string;
  gics_sub_industry?: string;
  // Revenue model
  revenue_model?: string;
  facebook?: string;
  twitter?: string;
  linkedIn?: string;
  instagram?: string;
  avatar?: {
    url: string;
    optimized500x300?: string;
  } | null;
  background?: {
    url: string;
    optimized500x300?: string;
  } | null;
}

export interface MeResponse {
  success: boolean;
  user: UserProfile;
  company: CompanyProfile | null;
}

export const profileApi = {
  /**
   * Get current user profile and company information
   * Returns user info and company info if the user has a company
   */
  getMe: async (): Promise<MeResponse> => {
    try {
      console.log("🌐 profileApi.getMe: Making API call to /me");
      const response = await axiosInstance.get<MeResponse>("/me");
      console.log("🌐 profileApi.getMe: Response received", response.data);

      if (!response.data.success) {
        throw new Error("Failed to fetch user profile");
      }

      return response.data;
    } catch (error: unknown) {
      console.error("❌ profileApi.getMe: Error fetching user profile:", error);
      const errorDetails = error as {
        message?: string;
        response?: {
          data?: { message?: string };
          status?: number;
        };
      };
      console.error("❌ Error details:", {
        message: errorDetails.message,
        response: errorDetails.response?.data,
        status: errorDetails.response?.status,
      });
      throw new Error(
        errorDetails.response?.data?.message || "Failed to fetch user profile"
      );
    }
  },
};
